/**
 * Genie Type registry.
 *
 * `agent.type` distinguishes the channel/format a Genie runs as. `null`
 * means the regular primary voice Genie — the default before any other
 * type is assigned. Shown as a badge on genie cards and the detail page.
 */
import type { LucideIcon } from "lucide-react";
import { Headphones, Mic } from "lucide-react";

export type GenieType = "voice" | "listener";

export interface GenieTypeMeta {
  id: GenieType;
  label: string;
  icon: LucideIcon;
}

export const GENIE_TYPES: GenieTypeMeta[] = [
  { id: "voice", label: "Voice", icon: Mic },
  { id: "listener", label: "Listener", icon: Headphones },
];

const TYPE_BY_ID: Record<GenieType, GenieTypeMeta> = GENIE_TYPES.reduce(
  (acc, meta) => {
    acc[meta.id] = meta;
    return acc;
  },
  {} as Record<GenieType, GenieTypeMeta>,
);

export const DEFAULT_GENIE_TYPE: GenieType = "voice";

export const getGenieTypeMeta = (type: string | null | undefined): GenieTypeMeta => {
  if (type && (type as GenieType) in TYPE_BY_ID) {
    return TYPE_BY_ID[type as GenieType];
  }
  return TYPE_BY_ID[DEFAULT_GENIE_TYPE];
};
